import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { Comments, TableHeader, TableLoader } from "../../commons";
import FullScreenDialog from "../../commons/FullScreenDilog/FullScreenDilog";
import { GetScheduledJobsHourPayloadType } from "../../../commonTypes/schedulingTypes";
import {
  getSingleJobsScheduledListAction,
  resetJobScheduledHoursList,
} from "../../../redux/scheduling";
import { resetSession } from "../../../redux/auth";
import { SingleJobsScheduledHoursListType } from "../../../redux/scheduling/schedulingTypes";
import ViewJobClosureJobDetails from "./ViewJobClosureJobDetails";
import { useEffect, useState } from "react";
import {
  AddJobsPayload,
  AllOpenJobChecklistDataType,
  GetAllOpenJobCheckListPayloadType,
  SingleJobPayload,
} from "../../../commonTypes/jobsType";
import {
  getAllOpenJobChecklistAction,
  getJobCommentsDetailsAction,
  getJobLinksDetailsAction,
  getSingleJobsAction,
  resetAllOpenJobChecklistSingleData,
  updateJobsAction,
} from "../../../redux/jobs";
import {
  DocumentsLinkType,
  JobProgressCommentType,
} from "../../../redux/listing/listingTypes";
import {
  GetAllDocumentsLinkPayloadType,
  GetJobProgressCommentsPayload,
} from "../../../commonTypes/listing";
import {
  resetDocumentsLinkList,
  resetJobProgressCommentsListing,
  resetJobProgressCommentsSuccess,
} from "../../../redux/listing";
import {
  addJobClosureRejectCommentAction,
  getJobClosureRatingListAction,
  resetJobClosureRatingList,
} from "../../../redux/thinksToDo";
import {
  AddJobClosureRejectCommentPayloadType,
  GetJobClosureRatingListPaylodType,
} from "../../../commonTypes/thinksToDoTypes";
import { JobClosureRatingListType } from "../../../redux/thinksToDo/thinksToDoType";
import { USER_WORKING_ON_JOBS_HEADERS } from "../../../constant/tableHeadersConstants/usersWorkingOnSpecificJobHeaderConst";
import UsersWorkingOnSpecificJobTable from "../../JobListing/ShowUserWorkingJobModal/UsersWorkingOnSpecificJobTable";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import { noResultIcon } from "../../../assets/images";
import { GetTimeSheetUserWorkOnSpecificJobPayloadType } from "../../../commonTypes/timeSheetTypes";
import { getOpenJobChargedHoursTimesheetAction, getTimesheetReportHoursForSpecificJobAction } from "../../../redux/timeSheet";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { OpenJobChargedHoursTimesheetListType } from "../../../redux/timeSheet/timeSheetType";
import CheckListModalViewcontainer from "../../JobListing/JobChecklist/CheckListModalViewcontainer";
import useDebounce from "../../../customHooks/useDebounce";

type TabsType = {
  name: string;
  label: string;
};

const tabs: TabsType[] = [
  {
    name: "Job Comments",
    label: "allComments",
  },
  {
    name: "Job Links",
    label: "allLink",
  },
  {
    name: "User Working Job",
    label: "userWorkingJob",
  },
  {
    name: "View Checklist",
    label: "viewChecklist",
  },
];
type AppProps = {
  token: string | null;
  modal: boolean;
  hideUserWorkingTab?: boolean;
  fetching: boolean;
  jobFetching: boolean;
  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;
  toggleModal: any;
  jobTypeId: any;
  singleJobsData: any;
  type?: string;
  totaltime: string;
  specificUsersJobList: any[];
  jobId: any | string | number;
  singleJobScheduledHoursSum: number;
  documentsLinkList: [] | DocumentsLinkType[];
  jobProgressCommentsFetching: boolean;
  jobProgressCommentsList: [] | JobProgressCommentType[];
  jobProgressCommentsSuccess: number | null;
  loginData: LoginResponseType;
  dispatchGetSingleJobScheduledHoursAction: (
    data: GetScheduledJobsHourPayloadType
  ) => void;
  singleJobScheduledHoursList: SingleJobsScheduledHoursListType[] | [];
  dispatchResetJobScheduledHoursList: () => void;
  dispatchResetSession: () => void;
  dispatchGetSingleJobsAction: (data: SingleJobPayload) => void;

  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => void;
  dispatchGetDocumentsLinkAction: (
    data: GetAllDocumentsLinkPayloadType
  ) => void;
  dispatchResetJobProgressCommentsListing: () => void;
  dispatchResetJobProgressCommentsSuccess: () => void;
  dispatchResetDocumentsLinkList: () => void;
  dispatchAddJobClosureRejectCommentAction: (
    data: AddJobClosureRejectCommentPayloadType
  ) => void;
  dispatchResetJobClosureRatingList: () => void;
  dispatchGetJobClosureRatingListAction: (
    data: GetJobClosureRatingListPaylodType
  ) => void;
  jobClosureRatingList: JobClosureRatingListType | null;
  dispatchUpdateJobs: (data: AddJobsPayload) => void;
  handleSentJobForClosuring?: (data: any) => void;
  jobCompletionTab?: boolean;
  dispatchGetTimesheetReportHoursForSpecificJobAction: (
    data: GetTimeSheetUserWorkOnSpecificJobPayloadType
  ) => void;
  dispatchGetOpenJobChargedHoursTimesheetAction: (data: GetScheduledJobsHourPayloadType) => void;
  openJobChargedHoursTimesheetList: OpenJobChargedHoursTimesheetListType[] | [];
  openJobChargedHoursTimesheetTotalSum: number;
  allOpenJobChecklistData: [] | AllOpenJobChecklistDataType[];
  dispatchGetAllOpenJobCheckListData: (
    data: GetAllOpenJobCheckListPayloadType
  ) => void;
  dispatchResetAllOpenJobChecklistSingleData: () => void;
  history?: any
};

const JobClosureApproveAndSendModal = ({
  token,
  modal,
  jobId,
  toggleModal,
  singleJobsData,
  type,
  jobTypeId,
  hideUserWorkingTab,
  specificUsersJobList,
  singleJobScheduledHoursSum,
  dispatchGetSingleJobScheduledHoursAction,
  singleJobScheduledHoursList,
  dispatchResetJobScheduledHoursList,
  dispatchResetSession,
  dispatchGetSingleJobsAction,
  fetching,
  jobFetching,
  statusCode,
  success,
  error,
  message,
  loginData,
  documentsLinkList,
  jobProgressCommentsFetching,
  jobProgressCommentsList,
  jobProgressCommentsSuccess,
  handleSentJobForClosuring,
  dispatchGetAllJobProgressCommentsAction,
  dispatchGetDocumentsLinkAction,
  dispatchResetJobProgressCommentsListing,
  dispatchResetJobProgressCommentsSuccess,
  dispatchResetDocumentsLinkList,
  dispatchAddJobClosureRejectCommentAction,
  dispatchResetJobClosureRatingList,
  dispatchGetJobClosureRatingListAction,
  jobClosureRatingList,
  dispatchUpdateJobs,
  totaltime,
  jobCompletionTab,
  dispatchGetTimesheetReportHoursForSpecificJobAction,
  dispatchGetOpenJobChargedHoursTimesheetAction,
  openJobChargedHoursTimesheetList,
  openJobChargedHoursTimesheetTotalSum,
  dispatchGetAllOpenJobCheckListData,
  allOpenJobChecklistData,
  dispatchResetAllOpenJobChecklistSingleData,
  history
}: AppProps) => {
  const [data, setData] = useState<[] | any[]>([]);
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const [showCommentBox, setShowCommentBox] = useState(false);
  const [comment, setComment] = useState("");
  const [totalScheduleHours, setTotalScheduleHours] = useState<number>(0);
  const [particulerjobsUsersList, setParticulerjobsUsersList] = useState<any>(
    []
  );
  const [checklistSearchData, setChecklistSearchData] = useState<string>("");


  //========== User Management ==========//
  const [
    isPendingApprovalApproveOrRejectButtonPresent,
    setIsPendingApprovalApproveOrRejectButtonPresent,
  ] = useMenuCheck();
  const [
    isAllOpenJobCheckListDetailPresent,
    setAllOpenJobCheckListDetailPresent,
  ] = useMenuCheck("");
  //====================//

  const totalHours = totaltime
    ? totaltime?.includes(".")
      ? Number(totaltime).toFixed(2)
      : 0
    : "";

  useEffect(() => {
    dispatchResetJobScheduledHoursList();
    dispatchResetJobClosureRatingList();
    setIsPendingApprovalApproveOrRejectButtonPresent(
      "All Open Approval Pending Jobs Approve or Reject",
      "menu"
    );
    setAllOpenJobCheckListDetailPresent("All Open Job Checklist", "menu");

    if (token && jobTypeId) {
      let finalData: any = {
        token,
        job_id: jobTypeId,
      };
      dispatchGetSingleJobScheduledHoursAction(finalData);
      dispatchGetOpenJobChargedHoursTimesheetAction(finalData)
    }
    if (token && jobTypeId) {
      let finalData: any = {
        token,
        jobId: jobTypeId,
      };
      dispatchGetJobClosureRatingListAction(finalData);
    }
    if (token && jobId) {
      let data: any = {
        token,
        id: jobId,
      };
      dispatchGetSingleJobsAction(data);
    }
  }, []);

  useEffect(() => {
    if (
      jobClosureRatingList?.ratings?.length &&
      jobClosureRatingList?.ratings?.length > 0
    ) {
      const totalHours = jobClosureRatingList?.ratings?.reduce(
        (sum: any, item: any) => sum + (item?.hours ? +item.hours : 0),
        0
      );
      setTotalScheduleHours(totalHours);
    }
  }, [jobClosureRatingList?.ratings]);

  useEffect(() => {
    if (
      jobClosureRatingList?.ratings?.length &&
      jobClosureRatingList?.ratings?.length > 0
    ) {
      const usersList: any[] = jobClosureRatingList?.ratings.map(
        (user: any) => {
          return {
            comment: user?.comment ? user?.comment : "",
            profile_pic: user?.user?.profile_pic
              ? user?.user?.profile_pic?.file_url
              : null,
            rating: user?.rating ? user?.rating : "",
            hours: user?.hours ? user?.hours : "",
            user_id: user?.user?.user_id ? user?.user?.user_id : null,
            user_name: user?.user?.last_name
              ? `${user?.user?.first_name + " " + user?.user?.last_name}`
              : user?.user?.first_name,
            job_title: user?.user?.job_title ? user?.user?.job_title : "",
          };
        }
      );

      setParticulerjobsUsersList([...usersList]);
    } else {
      const usersList: {
        rating: string;
        comment: string;
        profile_pic: any;
        hours: number;
        user_id: number;
        user_name: string;
        job_title: string;
      }[] = openJobChargedHoursTimesheetList?.length
          ? openJobChargedHoursTimesheetList.map((user: any) => {
            return {
              ...user,
              rating: "",
              comment: "",
              hours: user?.total_hours ? user?.total_hours : 0,
            };
          })
          : [];

      setParticulerjobsUsersList([...usersList]);
    }
  }, [openJobChargedHoursTimesheetList, jobClosureRatingList]);

  useEffect(() => {
    dispatchResetJobProgressCommentsListing();
    dispatchResetAllOpenJobChecklistSingleData();
    dispatchResetDocumentsLinkList();
    if (activeTab === "allComments") {
      let finalData: GetJobProgressCommentsPayload = {
        job_id: jobId,
        token,
      };
      dispatchGetAllJobProgressCommentsAction(finalData);
    }
    if (activeTab === "allLink") {
      let finalData: GetAllDocumentsLinkPayloadType = {
        job_id: jobId,
        token,
      };

      dispatchGetDocumentsLinkAction(finalData);
    }
    if (activeTab === "userWorkingJob" && jobTypeId) {
      let finalData = {
        job_id: jobTypeId,
        token,
      };
      let data = {
        job_id: jobTypeId,
        token,
      };
      dispatchGetSingleJobScheduledHoursAction(finalData);
      dispatchGetTimesheetReportHoursForSpecificJobAction(data);
    }
    else if (activeTab === "viewChecklist") {
      if (token) {
        let finalData = {
          token,
          jobId: jobTypeId,
          // searchTerm,
        };
        dispatchGetAllOpenJobCheckListData(finalData);
      }
    }
  }, [activeTab]);

  useEffect(() => {
    let newData: any[] = [];
    let newSingleJobScheduledHoursList = singleJobScheduledHoursList?.length
      ? JSON.parse(JSON.stringify(singleJobScheduledHoursList))
      : [];

    if (
      specificUsersJobList?.length > 0 &&
      !newSingleJobScheduledHoursList?.length
    ) {
      newData = specificUsersJobList;
    } else if (
      singleJobScheduledHoursList?.length > 0 &&
      !specificUsersJobList?.length
    ) {
      newData = singleJobScheduledHoursList;
    } else if (
      singleJobScheduledHoursList?.length > 0 &&
      newSingleJobScheduledHoursList?.length > 0
    ) {
      let p1 = 0;
      let p2 = 0;
      while (p1 < specificUsersJobList?.length) {
        if (
          specificUsersJobList[p1]?.user_id ==
          newSingleJobScheduledHoursList[p2]?.user_id
        ) {
          newData.push({
            ...specificUsersJobList[p1],
            total_hours: newSingleJobScheduledHoursList[p2]?.total_hours,
          });
          newSingleJobScheduledHoursList?.splice(p2, 1);
          p1++;
          p2 = 0;
        } else if (p2 > newSingleJobScheduledHoursList?.length - 1) {
          newData.push({ ...specificUsersJobList[p1] });
          p1++;
          p2 = 0;
        } else {
          p2++;
        }
      }
      for (let i = 0; i < newSingleJobScheduledHoursList?.length; i++) {
        newData.push(newSingleJobScheduledHoursList[i]);
      }
    }
    setData([...newData]);
  }, [specificUsersJobList, singleJobScheduledHoursList]);

  const updatedParticulerjobsUsersList = particulerjobsUsersList?.map((user: any) => ({
    ...user,
    rating: user?.rating === "" ? [] : user?.rating,
  }));

  const allRatingsEmpty = updatedParticulerjobsUsersList?.every((user: any) => user?.rating?.length === 0);
  const handleRejectWithComment = (id: any) => {
    let finalData = {
      token,
      id,
      comment,
      status: "2",
      ratings: allRatingsEmpty ? [] : particulerjobsUsersList,
    };
    dispatchAddJobClosureRejectCommentAction(finalData);
    toggleModal();
  };
  const handleCloseJobByRM = (id: any) => {
    let finalData = {
      _id: singleJobsData?._id,
      client_code: singleJobsData?.client_details?.client_code,
      job_type: singleJobsData?.job_type_details?._id,
      period_ended: singleJobsData?.period_ended,
      job_priority: singleJobsData?.job_priority,
      target_start_date: singleJobsData?.target_start_date,
      target_end_date: singleJobsData?.target_end_date,
      job_description: singleJobsData?.job_description,
      currently_responsible: singleJobsData?.currently_responsible?.first_name,
      job_partner: singleJobsData?.job_partner?.user_id,
      govt_officer: singleJobsData?.govt_officer?.user_id,
      job_manager: singleJobsData?.job_manager?.user_id,
      job_owner: singleJobsData?.job_owner?.user_id,
      agreed_fee: singleJobsData?.agreed_fee,
      budget_total: singleJobsData?.budget_total,
      job_status: "Closed",
      job_id: singleJobsData?.job_id,
    };
    dispatchUpdateJobs({ data: finalData, token });
    toggleModal();
  };
  const handleReject = () => {
    setShowCommentBox(true);
  };
  const handleApprove = () => {
    setShowCommentBox(false);
    let finalData = {
      token,
      id: jobTypeId,
      comment,
      status: "3",
      ratings: particulerjobsUsersList,
    };
    dispatchAddJobClosureRejectCommentAction(finalData);
    toggleModal();
  };

  const handleCommentChange = (e: any) => {
    setComment(e.target.value);
  };

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };
  const renderTabs = () => {
    const filterTabs: TabsType[] = hideUserWorkingTab ? tabs.filter(el => el?.label !== "userWorkingJob") : tabs;
    const finalTab = filterTabs?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className="pointer mr-3"
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 5px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "14px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${activeTab === tab?.label
              ? "active-tab-bottom-border"
              : "not-active-tab-bottom-border"
              }`}
          ></div>
        </div>
      );
    });
    return finalTab;
  };

  const renderAllComments = () => {
    const finalComments = jobProgressCommentsList?.map(
      (data: JobProgressCommentType, index: number) => {
        let finalName = !data?.first_name?.length
          ? `${data?.company_name?.slice(0, 25)}...`
          : `${data.first_name} ${data?.last_name}`;
        return (
          <Comments
            key={index}
            commenterName={finalName}
            commentTime={data?.created_at}
            commentText={data?.comment}
            image={data?.profile_pic}
            typeJobClosure={"jobClosure"}
          />
        );
      }
    );
    return finalComments;
  };
  const fetchNewChecklistData = (searchData?: any) => {
    if (token && jobTypeId) {
      let finalData = {
        token,
        jobId: jobTypeId,
        searchTerm: searchData,
      };
      dispatchGetAllOpenJobCheckListData(finalData);
    }
  };
  const handleSearch = (e: any) => {
    let value = e.target.value;
    setChecklistSearchData(value);
  };
  useDebounce(
    () => {
      if (checklistSearchData?.length) {
        fetchNewChecklistData(checklistSearchData);
      } else {
        if (token && jobTypeId) {
          let finalData = {
            token,
            jobId: jobTypeId,
            searchTerm: "",
          };
          dispatchGetAllOpenJobCheckListData(finalData);
        }
      }
    },
    500,
    [checklistSearchData]
  );
  const renderAllViewChecklist = () => {
    return <div className="jobsType job_checklist">
      <CheckListModalViewcontainer
        data={allOpenJobChecklistData}
        jobSingleData={jobTypeId}
        history={history}
        handleSearch={handleSearch}
        dispatchResetAllOpenJobChecklistSingleData={dispatchResetAllOpenJobChecklistSingleData}
        isAllOpenJobCheckListDetailPresent={isAllOpenJobCheckListDetailPresent}
        searchSize={4}
        emptyImageSize={"40%"}
        actionRemove={true}
        checklistSearchData={checklistSearchData}
        jobFetching={jobFetching}
      />
    </div>
  }

  const renderAllparticulerJobUsers = () => {
    return (
      <>
        <div className="d-flex col-md-12 mb-3">
          {data?.length > 0 ? (
            <div className="row col-md-12">
              <div style={{ minWidth: "95%" }}>
                <div className="table-bordered">
                  <table className="table">
                    <thead
                      className="text-left sticky-table-header"
                      style={{
                        backgroundColor: "#f4f6f8",
                        color: "#464f60",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {/*  */}
                      <tr
                        style={{
                          color: "#464f60",
                          backgroundColor: "#e8ecf0",
                        }}
                      >
                        <td>
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#464f60",
                            }}
                          >
                            TOTAL
                          </span>
                        </td>
                        <td></td>

                        <td
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#464f60",
                          }}
                        >
                          {totalHours ? totalHours : 0}
                        </td>
                        <td
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#464f60",
                          }}
                        >
                          {singleJobScheduledHoursSum
                            ? singleJobScheduledHoursSum
                              ?.toString()
                              ?.includes(".")
                              ? +singleJobScheduledHoursSum?.toFixed(2)
                              : singleJobScheduledHoursSum
                            : 0}
                        </td>
                      </tr>
                      {/*  */}
                      <TableHeader tableHeader={USER_WORKING_ON_JOBS_HEADERS} />
                    </thead>
                    <tbody>
                      <UsersWorkingOnSpecificJobTable
                        // data={specificUsersJobList}
                        data={data}
                        tableHeaders={USER_WORKING_ON_JOBS_HEADERS}
                      />
                      {/* {fetching && <div>{<InfiniteLoader />}</div>} */}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <div
              className="col-md-12"
              style={{
                display: "flex",
                paddingBottom: "6rem",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={noResultIcon} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span> No users assigned to this job </span>
                <div
                  style={{
                    alignItems: "center",
                    fontSize: "13px",
                    color: "#262a44",
                    textAlign: "center",
                  }}
                >
                  <p className="mb-0">
                    Please contact this job manager to assign{" "}
                  </p>
                  <p className="mb-0">users for this job</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  };
  const renderAllRecordings = () => {
    const finalComments = documentsLinkList?.map((data: any, index: number) => {
      let finalName = !data?.first_name?.length
        ? `${data?.company_name?.slice(0, 25)}...`
        : `${data.first_name} ${data?.last_name}`;
      const clientName = {
        value: singleJobsData?.client_details?.client_code,
        label: `(${singleJobsData?.client_details?.client_code}) ${singleJobsData?.client_details?.company_name}`,
      };

      return (
        <Comments
          key={index}
          type={"recording"}
          commenterName={finalName}
          commentTime={data?.created_at}
          commentText={data?.link}
          image={data?.profile_pic}
          clientName={clientName}
        />
      );
    });
    return finalComments;
  };
  const jobBody = () => {
    return (
      <>
        {!fetching ? (
          <ViewJobClosureJobDetails
            data={particulerjobsUsersList}
            jobClosureRatingList={jobClosureRatingList}
            activeTab={activeTab}
            jobProgressCommentsFetching={jobProgressCommentsFetching}
            jobProgressCommentsList={jobProgressCommentsList}
            documentsLinkList={documentsLinkList}
            renderAllComments={renderAllComments}
            renderAllViewChecklist={renderAllViewChecklist}
            renderAllparticulerJobUsers={renderAllparticulerJobUsers}
            renderAllRecordings={renderAllRecordings}
            renderTabs={renderTabs}
            fetching={fetching}
            singleJobsData={singleJobsData}
            singleJobScheduledHoursSum={singleJobScheduledHoursSum}
            showCommentBox={showCommentBox}
            comment={comment}
            handleCommentChange={handleCommentChange}
            handleReject={handleReject}
            handleApprove={handleApprove}
            handleRejectWithComment={handleRejectWithComment}
            setParticulerjobsUsersList={setParticulerjobsUsersList}
            viewJobDetailsType={type}
            handleCloseJobByRM={handleCloseJobByRM}
            jobCompletionTab={jobCompletionTab}
            loginData={loginData}
            toggleModal={toggleModal}
            totalHours={
              jobClosureRatingList?.ratings?.length &&
                jobClosureRatingList?.ratings?.length > 0
                ? totalScheduleHours
                : openJobChargedHoursTimesheetTotalSum
                  ? openJobChargedHoursTimesheetTotalSum
                  : 0
            }
            handleSentJobForClosuring={handleSentJobForClosuring}
            isPendingApprovalApproveOrRejectButtonPresent={
              isPendingApprovalApproveOrRejectButtonPresent
            }
            openJobChargedHoursTimesheetTotalSum={openJobChargedHoursTimesheetTotalSum}
            jobFetching={jobFetching}
          />
        ) : (
          <TableLoader Rows={10} ColumnPerRow={5} />
        )}
      </>
    );
  };
  const handleAddMangerFeedback = () => { };
  return (
    <div>
      <FullScreenDialog
        success={success}
        onClose={toggleModal}
        showSchedulingEstimateData={singleJobScheduledHoursList}
        title={
          type == "Employee"
            ? "View Job Details"
            : "Approve Job & Send for Closure"
        }
        body={jobBody}
        onSubmit={handleAddMangerFeedback}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  singleJobScheduledHoursList: state.scheduling.singleJobScheduledHoursList,
  fetching: state.scheduling.fetching,
  jobFetching: state.jobs.fetching,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
  message: state.scheduling.message,
  singleJobsData: state.jobs.singleJobs,
  jobProgressCommentsFetching: state.jobs.jobProgressCommentsFetching,
  jobProgressCommentsList: state.jobs.jobProgressCommentsList,
  jobProgressCommentsSuccess: state.jobs.jobProgressCommentsSuccess,
  documentsLinkList: state.jobs.documentsLinkList,
  singleJobScheduledHoursSum: state.scheduling.singleJobScheduledHoursSum,
  jobClosureRatingList: state.thinksToDo.jobClosureRatingList,
  totaltime: state.timeSheet.totalWorkingHoursOnSpecificJob,
  loginData: state.auth.loginData,
  specificUsersJobList: state.timeSheet.reportForSpecificJobList,
  openJobChargedHoursTimesheetList: state.timeSheet.openJobChargedHoursTimesheetList,
  openJobChargedHoursTimesheetTotalSum: state.timeSheet.openJobChargedHoursTimesheetTotalSum,
  allOpenJobChecklistData: state.jobs.allOpenJobChecklistData,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetSingleJobScheduledHoursAction: (
    data: GetScheduledJobsHourPayloadType
  ) => dispatch(getSingleJobsScheduledListAction(data)),
  dispatchResetJobScheduledHoursList: () =>
    dispatch(resetJobScheduledHoursList()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetSingleJobsAction: (data: SingleJobPayload) =>
    dispatch(getSingleJobsAction(data)),
  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => dispatch(getJobCommentsDetailsAction(data)),
  dispatchGetDocumentsLinkAction: (data: GetAllDocumentsLinkPayloadType) =>
    dispatch(getJobLinksDetailsAction(data)),
  dispatchResetJobProgressCommentsListing: () =>
    dispatch(resetJobProgressCommentsListing()),
  dispatchResetJobProgressCommentsSuccess: () =>
    dispatch(resetJobProgressCommentsSuccess()),
  dispatchResetDocumentsLinkList: () => dispatch(resetDocumentsLinkList()),
  dispatchResetJobClosureRatingList: () =>
    dispatch(resetJobClosureRatingList()),
  dispatchAddJobClosureRejectCommentAction: (
    data: AddJobClosureRejectCommentPayloadType
  ) => dispatch(addJobClosureRejectCommentAction(data)),
  dispatchGetJobClosureRatingListAction: (
    data: GetJobClosureRatingListPaylodType
  ) => dispatch(getJobClosureRatingListAction(data)),
  dispatchUpdateJobs: (data: AddJobsPayload) =>
    dispatch(updateJobsAction(data)),
  dispatchGetTimesheetReportHoursForSpecificJobAction: (
    data: GetTimeSheetUserWorkOnSpecificJobPayloadType
  ) => dispatch(getTimesheetReportHoursForSpecificJobAction(data)),
  dispatchGetOpenJobChargedHoursTimesheetAction: (data: GetScheduledJobsHourPayloadType) => {
    dispatch(getOpenJobChargedHoursTimesheetAction(data))
  },
  dispatchGetAllOpenJobCheckListData: (
    data: GetAllOpenJobCheckListPayloadType
  ) => dispatch(getAllOpenJobChecklistAction(data)),
  dispatchResetAllOpenJobChecklistSingleData: () =>
    dispatch(resetAllOpenJobChecklistSingleData()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobClosureApproveAndSendModal);
